export abstract class DebugEvent {
	protected static eventName: string;

	constructor(parameters: any = null) {
		for (let i in parameters) {
			this[i] = parameters[i];
		}
	}

	/**
	 * Get event name from the child item ('this' can used get static values in Typescript)
	 * @return {string} eventName
	 */
	get eventNameFromStatic(): string {
		return this.constructor['eventName'];
	}
}
